import { Button, Form } from 'react-bootstrap';
import React, { useState } from 'react';

export const RegionalPricing = (props) => {
  const [regionChecked, setRegionChecked] = useState(false);

  function checkRegion(e) {
    setRegionChecked(e.target.checked);
    props.updateRegionArr(e);
  }

  function onClickButton(e, index) {
    if(props.products[index][props.region].lockRegionPrices){
      props.updateRegionalProductAttribute(e, props.region, index, 'lockRegionPrices');
    } else {
      props.updateRegionalProductAttribute(e, props.region, index, 'empty');
    }

    // console.log('test3', props.region, index);
    // if (buttonState === buttonLabels.length - 1) {
    //   setButtonState(0);
    // } else {
    //   setButtonState(buttonState + 1);
    // }
    // props.updateRegionalProductAttribute(e, props.region, index);
  }

  return (
    <>
      {Object.values(props.products).map((testProduct, index) => {
        return (
          <>
            {props.products.length > 1 && testProduct.name}
            <table>
              <thead>
                <tr>
                  <th style={{ width: '2%' }}>Select</th>
                  <th style={{ width: '7%' }}>MinPrice</th>
                  <th style={{ width: '7%' }}>MaxPrice</th>
                  <th style={{ width: '7%' }}>BreakEven</th>
                  <th style={{ width: '7%' }}>MinMargin</th>
                  <th style={{ width: '7%' }}>maxMargin</th>
                  <th style={{ width: '7%' }}>PPP ID</th>
                  <th style={{ width: '7%' }}>Lock Prices from updates</th>
                </tr>
              </thead>
              <tbody>
                <tr>  
                  <td>
                    <input
                      type='checkbox'
                      checked={props.selectedRegions.indexOf(props.region) === -1 ? false : true}
                      name={props.region}
                      onClick={(e) => checkRegion(e)}
                    ></input>
                  </td>
                  <td>
                    <Form.Control
                      name='minPrice'
                      type='number'
                      value={testProduct[props.region].minPrice}
                      onChange={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                      disabled={props.products[index][props.region].lockRegionPrices}
                    />
                  </td>
                  <td>
                    <Form.Control
                      name='maxPrice'
                      type='number'
                      value={testProduct[props.region].maxPrice}
                      onChange={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                      disabled={props.products[index][props.region].lockRegionPrices}
                    />
                  </td>
                  <td>{testProduct[props.region].breakEvenPrice}</td>
                  <td>
                    <Form.Control
                      name='minTargetMargin'
                      type='number'
                      value={testProduct[props.region].minTargetMargin}
                      onChange={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                    />
                  </td>
                  <td>
                    <Form.Control
                      name='maxTargetMargin'
                      type='number'
                      value={testProduct[props.region].maxTargetMargin}
                      onChange={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                    />
                  </td>
                  <td>
                    <select
                      name='strategyId'
                      type='number'
                      value={testProduct[props.region].strategyId}
                      onChange={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                    >
                      <option value='1'>1</option>
                      <option value='2'>2</option>
                      <option value='3'>3</option>
                      <option value='4'>4</option>
                      <option value='5'>5</option>
                      <option value='6'>6</option>
                      <option value='7'>7</option>
                      <option value='8'>8</option>
                      <option value='9'>9</option>
                      <option value='10'>10</option>
                      <option value='11'>11</option>
                      <option value='12'>12</option>
                    </select>
                  </td>
                  <td>
                    <Button
                      size='sm'
                      variant={props.products[index][props.region].lockRegionPrices ? 'danger' :  'primary'}
                      name='lockButton'
                      // onClick={(e) => props.updateRegionalProductAttribute(e, props.region, index)}
                      onClick={(e) => onClickButton(e, index)}
                    >
                      {props.products[index][props.region].lockRegionPrices ? 'Prices Locked'  : 'Unlocked'}
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        );
      })}
    </>
  );
};
